import { useEffect, useState } from "react"

import { getCountries } from "../Containers/User/services"
import { getCachedCountries, saveCountriesToCache } from "../Utils/phoneCountriesCache"
import { useExternalDemoMode } from "./useExternalDemoMode"

export function usePhoneCountries() {
  const [countries, setCountries] = useState(() => getCachedCountries() || [])
  const [loading, setLoading] = useState(() => countries.length === 0)
  const externalDemoMode = useExternalDemoMode()

  useEffect(() => {
    if (window.location.hostname.includes("partner") || externalDemoMode) {
      setLoading(false)
      return
    }

    const load = async () => {
      const res = await getCountries()
      const data = res?.data || []

      setCountries(data)
      saveCountriesToCache(data)
      setLoading(false)
    }

    load()
  }, [])

  return { countries, loading }
}
